module.exports = __webpack_public_path__ + "static/img/3sing.c10dbfa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3sing.png
// module id = 41rM
// module chunks = 1